import { useNavigate } from 'react-router-dom';
import { LabsOrderHeader } from './labs-order-header';
import { ROUTE_LABS } from '../../../../constants/routes';
import { useLabOrder } from '../labs-order.page';
import '../../dashboard/dashboard-reset.css';

interface LabsOrderStepLayoutProps {
  currentStep: 1 | 2 | 3 | 4 | 5;
  children: React.ReactNode;
  footer?: React.ReactNode;
  showBackButton?: boolean;
  onBack?: () => void;
  onClose?: () => void;
}

export function LabsOrderStepLayout({
  currentStep,
  children,
  footer,
  showBackButton = true,
  onBack,
  onClose,
}: LabsOrderStepLayoutProps) {
  const navigate = useNavigate();
  const { source } = useLabOrder();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(ROUTE_LABS);
    }
  };

  return (
    <div className="dashboard-reset min-h-screen w-full bg-[#0E1D27]">
      <div className="flex h-screen w-full flex-col items-center">
        <LabsOrderHeader
          currentStep={currentStep}
          onBack={handleBack}
          onClose={source === 'risk_assessment' ? undefined : handleClose}
          showBackButton={showBackButton}
          source={source}
        />

        <div className="relative flex h-[85vh] w-full flex-col rounded-t-[28px] bg-white shadow-[0px_10px_100px_0px_rgba(85,94,104,0.1)] backdrop-blur-[10px]">
          <div className="mx-auto w-full max-w-2xl flex-1 overflow-y-auto px-4 py-8">
            {children}
          </div>
          {footer && (
            <div className="mx-auto w-full max-w-2xl shrink-0 px-4 pb-8">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
